/**
 * @description getCookieValue function
 * This function retrieves the value of a specified cookie by its name.
 * It searches through the document's cookies, splits them by semicolon,
 * and checks if the cookie name matches the provided name.
 * If a match is found, it returns the cookie's value.
 * If the cookie is not found or if the document is not defined,
 * the function returns null.
 *
 * @param {string} name The name of the cookie to retrieve.
 * @returns {string|null} The value of the cookie if found, otherwise null.
 */
export const getCookieValue = (name) => {
    if (typeof document !== 'undefined') {
        const nameEQ = name + '=';
        const cookies = document.cookie?.split(';');
        for (let cookie of cookies) {
            cookie = cookie.trim();
            if (cookie.indexOf(nameEQ) === 0) {
                return cookie.substring(nameEQ.length);
            }
        }
    }
    return null;
};
